import { connect } from 'react-redux';
import InviteParticipants from './InviteParticipants';

import { saveRanking } from '../../service/ranking';

import config from '@config';

export const switchIsOpen = () => (dispatch, getState) => {
  let { jwToken, rankingDetails } = getState();
  dispatch({ type: 'RANKING_PARTICIPANTS_SAVING', payload: true });
  return saveRanking(jwToken, rankingDetails._id, {
    isOpen: !rankingDetails.isOpen,
  }).then((res) => {
    dispatch({
      type: 'RANKING_DETAILS_SET',
      payload: res.data,
    });
    dispatch({ type: 'RANKING_PARTICIPANTS_SAVING', payload: false });
  });
};

export const regenInviteCode = () => (dispatch, getState) => {
  let { jwToken, rankingDetails } = getState();
  dispatch({ type: 'RANKING_PARTICIPANTS_SAVING', payload: true });
  return saveRanking(jwToken, rankingDetails._id, { inviteCode: true }).then(
    (res) => {
      dispatch({
        type: 'RANKING_DETAILS_SET',
        payload: res.data,
      });
      dispatch({ type: 'RANKING_PARTICIPANTS_SAVING', payload: false });
    }
  );
};

// rankingParticipants is still used as legacy, but could be moved into a different slice
export const mapStateToProps = ({ rankingDetails, rankingParticipants }) => ({
  inviteCode: `${String(config.inviteHost || `${config.host || ''}${config.basePath || ''}`).replace(/\/+$/, '')}/invitacion/${rankingDetails.inviteCode}`,
  isOpen: rankingDetails.isOpen,
  visible: rankingParticipants.visible,
  saving: rankingParticipants.saving,
});

export const mapDispatchToProps = (dispatch) => ({
  onRegenInviteCode: () => dispatch(regenInviteCode()),
  onSwitchOpen: () => dispatch(switchIsOpen()),
  onCancel: () => dispatch({ type: 'RANKING_PARTICIPANTS_CLEAR' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteParticipants);
